import axios from 'axios';
import { store } from '../redux/store';
import { logout } from '../redux/globalAction';

const base_url = process.env.REACT_APP_API_BASEURL;

const axiosInterceptor = axios.create({
  timeout: 10000,
  baseURL: base_url
});

axiosInterceptor.interceptors.request.use(
  (config) => {
    const token = store.getState()?.userInfo?.token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['Accept'] = 'application/json';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInterceptor.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    const status = error?.response?.status;

    if (status === 401) {
      store.dispatch(logout());
    }

    if (
      status === 403 &&
      (error?.response?.data?.message == 'Unauthorized access' ||
        error?.response?.data?.message == 'No leave found' ||
        error?.response?.data?.message == 'No leave found')
    ) {
      window.history.go(-1);
    }

    return Promise.reject(error?.response?.data || error);
  }
);

export default axiosInterceptor;
